import React from 'react';
import LocalizedStrings from 'react-localization';
import Widget from '../Widget/Widget'
import Slider from 'react-slick'
import './EmployeeStatusWidget.css'
import {chunkArray, flatten} from '../../../Utils/ArrayUtils'

class EmployeeStatusWidget extends React.Component {

  constructor(props) {
    super(props);
    this.strings = new LocalizedStrings({
     en:{
       noEmployees: 'There are no employees signed in',
       total: 'Total: '
     },
     de: {
       noEmployees: 'Kein mitarbeiter eingeloggt',
       total: 'Insgesamt: '
     }
    });

    if(props.language) {
      this.strings.setLanguage(props.language);
    }
  }

  getLocationSlides() {
    if(this.props.locations) {
      const locations = this.props.locations;
      var locationSlides = Object.keys(locations).map(function(key) {
          const location = locations[key];
          const employees = location.employees;

          var columnSize = 6;
          var colClass = 'col-2';

          const windowWidth = window.innerWidth;

          if(windowWidth >= 2000) {
            colClass = "col-2"
          } else if(employees.length <= 3) {
            colClass="col-4"
          } else if(employees.length < 6) {
            colClass = "col"
          }

          var rows = [];

          const numberOfRows = Math.ceil(employees.length / columnSize);
          const numberOfColumns = Math.ceil(employees.length / numberOfRows)

          var employeeChunks = chunkArray(employees, numberOfColumns);

          for(var i = 0; i < employeeChunks.length; i++) {
            var employeeColumns = employeeChunks[i];

            var columns = [];

            for(var j = 0; j < employeeColumns.length; j++) {
              const employee = employeeColumns[j];

              columns.push(
                <div className={colClass} key={employee.internalId}>
                  <img src={employee.image} alt={employee.firstName + " " + employee.lastName} className='rounded-circle img-fluid employee-status-widget-img mx-auto d-block'/>
                </div>
              )

            }

            rows.push(
              <div key={'row'+i} className="row align-items-center justify-content-center employee-status-widget-row">
                {columns}
              </div>
            )
          }

          var rowsForSlides = chunkArray(rows, 2);

          return rowsForSlides.map(function(rowsForSlide, index) {
            return this.buildSlide(key+"-"+index, key, rowsForSlide, employees.length)
          },this)

      }, this)

      return flatten(locationSlides);
    }
  }

  buildSlide(key, location, rows, signIncount) {
    return (
      <div key={key}>
        <div className="employee-status-widget-slide">
          <h1 className="text-center">{location}</h1>
          {rows}
          <div className="row align-items-center justify-content-center">
            <div className="col">
              <p className="text-center employee-status-widget-slide-sign-in-count-text">{ this.strings.total } {signIncount}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {

    var settings = {
     dots: true,
     infinite: true,
     speed: 500,
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows:false,
     draggable:false,
     autoplay:true,
     autoplaySpeed:5000,
     pauseOnHover:false
    };

    const locationSlides = this.getLocationSlides();

    if (locationSlides && locationSlides.length === 1) {
      settings.autoplay = false;
      settings.infinite = false;
    }

    if(locationSlides && locationSlides.length > 0) {
      return (
        <Widget {...this.props}>
          <div className="row widget-fullheight-row">
            <div className="col align-self-center">
              <Slider {...settings}>
                {locationSlides}
              </Slider>
            </div>
          </div>
        </Widget>
      )
    } else {
      return (<Widget {...this.props}>
        <div className="row widget-fullheight-row">
          <div className="col align-self-center">
            <h1 className="text-center">{ this.strings.noEmployees }</h1>
          </div>
        </div>
      </Widget>)
    }
  }
}

export default EmployeeStatusWidget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/EmployeeStatusWidget/EmployeeStatusWidget.js